import { NgModule } from '@angular/core';
import { LoaderOverlayModule } from '@epicuro-next/ataraxia/loader-overlay';
import { StorageModule } from '@epicuro-next/platform/storage';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { OverlayEffects, UserUiEffects } from './state/effects';
import { reducer, userUiFeatureKey } from './state/user-ui.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(userUiFeatureKey, reducer),
    EffectsModule.forFeature([UserUiEffects, OverlayEffects]),
    StorageModule,
    LoaderOverlayModule,
  ],
})
export class UserUiStateModule {}
